import { condensedChartsAtom } from "../state";
import { useAtom } from "jotai";
import clsx from "clsx";

export function CondenseToggle() {
    const [condensedCharts, setCondensedCharts] = useAtom(condensedChartsAtom);

    return (
        <div className="flex gap-2">
            <div
                className="group flex cursor-pointer gap-0.5"
                onClick={() => setCondensedCharts(true)}
            >
                <span
                    className={clsx(
                        condensedCharts ? "bg-white" : "bg-gray-500",
                        "size-2.5 rounded-[1px] group-hover:bg-white",
                    )}
                />
                <span
                    className={clsx(
                        condensedCharts ? "bg-white" : "bg-gray-500",
                        "size-2.5 rounded-[1px] group-hover:bg-white",
                    )}
                />
            </div>
            <div
                className={clsx(
                    "flex flex-col",
                    "group cursor-pointer gap-0.5",
                )}
                onClick={() => setCondensedCharts(false)}
            >
                <span
                    className={clsx(
                        !condensedCharts ? "bg-white" : "bg-gray-500",
                        "h-1 w-5 rounded-[1px] group-hover:bg-white",
                    )}
                />
                <span
                    className={clsx(
                        !condensedCharts ? "bg-white" : "bg-gray-500",
                        "h-1 w-5 rounded-[1px] group-hover:bg-white",
                    )}
                />
            </div>
        </div>
    );
}
